import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'

import { Card } from '../../../../../components'
import { getDetail, THEMES } from '../../../../../utils'
import { capitalize } from 'lodash'

/**
 * Contact Record Component
 * @param id
 * @param source
 * @param status
 * @returns {*}
 * @constructor
 */
const Record = ({ id, source, status }) => {
  return (
    <Card
      title='Record ID Detail'
      theme={THEMES.DARK_SLATE}>
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <div className='card_section'>
            <div className='card_section-subtitle'>Record ID</div>
            <div className='card_section-detail'>{getDetail(id)}</div>
          </div>
        </Grid>
        <Grid item xs={4}>
          <div className='card_section'>
            <div className='card_section-subtitle'>Source</div>
            <div className='card_section-detail'>{getDetail(capitalize(source))}</div>
          </div>
        </Grid>
        <Grid item xs={4}>
          <div className='card_section'>
            <div className='card_section-subtitle'>Status</div>
            <div
              className={`card_section-detail ${status && (status === 'gdpr' || status === 'dnq') ? 'section_detail--uppercase' : ''}`}>
              {getDetail(capitalize(status))}
            </div>
          </div>
        </Grid>
      </Grid>
    </Card>
  )
}

Record.propTypes = {
  id: PropTypes.string,
  source: PropTypes.string,
  status: PropTypes.string
}

export default Record
